import React, { memo, useMemo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, currentOrg,
}) {
  const payerFilter = useMemo(
    () => ({
      org: currentOrg,
    }),
    [currentOrg],
  );

  const contractFilter = useMemo(
    () => ({
      payer: row.payer ? row.payer.id : null,
    }),
    [row.payer],
  );

  return (
    <>
      <TableRow
        onClick={(e) => actions.onActivateRow(e, row.id)}
        selected={active}
        hover
      >
        <TableCell>
          <TableControls.ItemPicker
            value={row.payer}
            onChange={(e, v) => actions.onChange(e, row.id, { payer: v })}
            readOnly={fields.payer.read_only || readOnly}
            backend={fields.payer.resource}
            filter={payerFilter}
          />
        </TableCell>
        <TableCell>
          <TableControls.ItemPicker
            value={row.contract}
            onChange={(e, v) => actions.onChange(e, row.id, { contract: v })}
            readOnly={fields.contract.read_only || readOnly}
            backend={fields.contract.resource}
            filter={contractFilter}
          />
        </TableCell>
        <TableCell>
          <TableControls.StringInput
            value={row.payment_number}
            onChange={(e, v) => actions.onChange(e, row.id, { payment_number: v })}
            readOnly={fields.payment_notes.read_only || readOnly}
          />
        </TableCell>
        <TableCell>
          <TableControls.NumerInput
            value={row.order_amount}
            onChange={(e, v) => actions.onChange(e, row.id, { order_amount: v })}
            readOnly={fields.order_amount.read_only || readOnly}
            precision={2}
          />
        </TableCell>
      </TableRow>
      <TableRow
        onClick={(e) => actions.onActivateRow(e, row.id)}
        selected={active}
        hover
      >
        <TableCell colSpan={4}>
          <TableControls.StringInput
            value={row.payment_notes}
            onChange={(e, v) => actions.onChange(e, row.id, { payment_notes: v })}
            readOnly={fields.payment_notes.read_only || readOnly}
            placeholder="Примітка"
          />
        </TableCell>
      </TableRow>
    </>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    payer: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    contract: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    payment_number: PropTypes.string,
    order_amount: PropTypes.number,
    payment_notes: PropTypes.string,
  }).isRequired,
  fields: PropTypes.shape({
    payer: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    contract: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
    payment_number: PropTypes.shape({ read_only: PropTypes.bool }),
    order_amount: PropTypes.shape({ read_only: PropTypes.bool }),
    payment_notes: PropTypes.shape({ read_only: PropTypes.bool }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  currentOrg: PropTypes.number,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  currentOrg: null,
};

export default memo(Row);
